// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3Mz6v","label":"Radio_label__3n4Bz","checkMark":"Radio_checkMark__2eW49","disabled":"Radio_disabled__3cFDN"};